import { Enumify } from "enumify";

class Lit extends Enumify {
  static paper = new Lit({
    name: "논문",
  });
  static report = new Lit({
    name: "전문리포트",
  });
  static _ = this.closeEnum();

  constructor(props) {
    super();
    Object.defineProperties(this, Object.getOwnPropertyDescriptors(props));
  }
}

export default Lit;
